import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import {
  BillingDetails,
  BitbucketAccount,
  BitbucketGroup,
  BitbucketSearchOptions,
  BitbucketSearchParams,
  BitbucketUser,
  PublicUserProfile,
} from '@atlassian/cssxp-types-entitlement';
import { Results } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/bitbucket' }, ServiceProxyMap.ANS);

async function fetchPublicProfile(uuid: string) {
  const response = await client.get<PublicUserProfile>(`/accounts/${uuid}/public-profile`, {
    validateStatus: (status) => [200, 404].includes(status),
  });

  if (response.status === 404) {
    return null;
  }

  return response.data;
}

async function fetchBillingDetails(uuid: string) {
  const response = await client.get<BillingDetails>(`/accounts/${uuid}/billing-details`);

  return response.data;
}

async function fetchEntitlementDetails(uuid: string) {
  const response = await client.get<BitbucketAccount>(`/accounts/${uuid}/entitlement-details`);

  return response.data;
}

async function fetchValidBitbucketLink(uuid: string) {
  const response = await client.get<boolean>(`/hasValidBitbucketLink/${uuid}`);

  return response.data;
}

async function fetchAccountAdmins(params: BitbucketSearchParams & BitbucketSearchOptions) {
  const { id, ...searchOptions } = params;

  const response = await client.get<Results<BitbucketUser>>(`/accounts/${id}/admins`, {
    params: searchOptions,
  });

  return response.data;
}

async function fetchAccountUsers(params: BitbucketSearchParams & BitbucketSearchOptions) {
  const { id, ...searchOptions } = params;
  const response = await client.get<Results<BitbucketUser>>(`/accounts/${id}/users`, {
    params: searchOptions,
  });

  return response.data;
}

async function fetchGroupMemberships(params: BitbucketSearchParams & BitbucketSearchOptions) {
  const { id, ...searchOptions } = params;

  const response = await client.get<Results<BitbucketGroup>>(`/accounts/${id}/group-memberships`, {
    params: searchOptions,
  });

  return response.data;
}

async function changePlan(req: { uuid: string; planSlug: string }) {
  if (!req.uuid) {
    throw new Error('UUID missing');
  }

  const response = await client.put(`/accounts/${req.uuid}/plan`, {
    slug: req.planSlug,
  });

  return response.data;
}

export {
  fetchPublicProfile,
  fetchBillingDetails,
  fetchEntitlementDetails,
  fetchAccountAdmins,
  fetchAccountUsers,
  fetchGroupMemberships,
  changePlan,
  fetchValidBitbucketLink,
};
